<template>
  <section>
    <div class="overlay d-none d-lg-block"></div>
    <div class="row text-center text-lg-start">
      <div class="col-md-6 mx-sm-auto home-content">
        <base-img></base-img>
      </div>
      <div class="col col home-content">
        <div class="resume">
          <h2 class="headTitle">
            -I'M AHMED SANAD.
            <br />
            <span class="headSpan "> FULL STACK WEBDEVELOPER. </span>
          </h2>
          <p class="headP">
            As a full stack developer , I create seamless web applications that meet the needs of end-users and clients. I have a strong focus on Vue.js and .NET technologies, using my skills in HTML, CSS, JavaScript, C#, and database design to deliver efficient and scalable solutions. I have experience in styling with CSS preprocessors such as SASS, and utilizing popular UI libraries like Bootstrap and Tailwind CSS.
          
          </p>
          <div class="d-none d-md-block">
            <base-button mode="magicButton m-auto">
              <router-link to="/about">
                <h6>More About Me</h6>
                <font-awesome-icon :icon="['fa-solid', 'fa-arrow-right']" />
              </router-link>
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseImg from "../components/home/BaseImg.vue";
import { gsap } from "gsap";
import { tsLiteralType } from "@babel/types";
export default {
  components: { BaseImg },
  mounted() {
    this.headAnimation();
  },
  methods: {
    headAnimation() {
      const tl = gsap.timeline();
      tl.from(".headTitle", { opacity: 0, y: 30 ,ease: "linear",
    duration:1}).from('.headSpan',{opacity:0,y:30,duration:1,ease: "linear"}).from(".headP", {
        opacity: 0,
        y: 20,
        ease: "linear",
        duration:.6
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/views/home";
section {
  height: 100vh;
  // text-align: ;
}
</style>
